import React from 'react';

const LinkedInIcon = () => {
  return (
    <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.74417 22V7.15664H1.02824V22H5.74417ZM3.38682 5.12881C5.03134 5.12881 6.05499 3.98901 6.05499 2.56465C6.02435 1.10816 5.03141 0 3.41802 0C1.80489 0 0.75 1.10818 0.75 2.56465C0.75 3.98908 1.77339 5.12881 3.35603 5.12881H3.38667H3.38682ZM8.35443 22H13.0704V13.7107C13.0704 13.2671 13.101 12.8239 13.2255 12.5068C13.5665 11.6205 14.3424 10.7024 15.6452 10.7024C17.3517 10.7024 18.0344 12.0636 18.0344 14.059V21.9999H22.75V13.4888C22.75 8.92955 20.4234 6.80816 17.3206 6.80816C14.7766 6.80816 13.6595 8.29584 13.039 9.30909H13.0705V7.15633H8.35453C8.41642 8.54915 8.35453 21.9997 8.35453 21.9997L8.35443 22Z"
        fill="#013957"
      />
      <path
        d="M5.74417 22V7.15664H1.02824V22H5.74417ZM3.38682 5.12881C5.03134 5.12881 6.05499 3.98901 6.05499 2.56465C6.02435 1.10816 5.03141 0 3.41802 0C1.80489 0 0.75 1.10818 0.75 2.56465C0.75 3.98908 1.77339 5.12881 3.35603 5.12881H3.38667H3.38682ZM8.35443 22H13.0704V13.7107C13.0704 13.2671 13.101 12.8239 13.2255 12.5068C13.5665 11.6205 14.3424 10.7024 15.6452 10.7024C17.3517 10.7024 18.0344 12.0636 18.0344 14.059V21.9999H22.75V13.4888C22.75 8.92955 20.4234 6.80816 17.3206 6.80816C14.7766 6.80816 13.6595 8.29584 13.039 9.30909H13.0705V7.15633H8.35453C8.41642 8.54915 8.35453 21.9997 8.35453 21.9997L8.35443 22Z"
        fill="black"
        fillOpacity="0.2"
      />
    </svg>
  );
};

export default LinkedInIcon;
